import { makeAutoObservable } from 'mobx';

export default class ClosableStore {
    items: IClosableItem[] = [];
    counter: number = 1;

    constructor() {
        makeAutoObservable(this);
    }

    add(order: ClosableOrder, onClose: () => void) {
        const item = {
            id: this.counter++,
            order: order,
            onClose: onClose,
        };

        this.items = [
            ...this.items,
            item,
        ];

        return item.id;
    }

    delete(id: number) {
        this.items = this.items.filter(i => i.id != id);
    }

    clear() {
        this.items = [];
    }
}

export interface IClosableItem {
    id: number;
    order: ClosableOrder;
    onClose: () => void;
}

export enum ClosableOrder {
    Click = "Click",
    High = "High",
    Medium = "Medium",
    Low = "Low",
}